import { image } from './data/baseUrl'
import { sept2026ChangesRatingData } from '../constants/copyright'

export function isChangesRatingSept2026Active() {
  const now = new Date()

  // Изменить дату начала на актуальную после тестирования
  const startDate = new Date('2026-09-01T00:00:00')
  const endDate = new Date('2026-09-20T23:59:59')

  return now >= startDate && now <= endDate
}

export const showChangesRatingSept2026Modal = ({
  modalServiceDataKey,
  getServiceData,
  saveServiceData,
  addModal,
  state,
}) => {
  if (!isChangesRatingSept2026Active()) return

  if (getServiceData(modalServiceDataKey)) return

  const modalData = sept2026ChangesRatingData[state]

  const setServiceData = () => saveServiceData(modalServiceDataKey, true)

  addModal({
    id: 'onboardingModal',
    type: 'onboardingModal',
    props: {
      image: image(modalData.image),
      title: modalData.title,
      description: modalData.description,
      buttons: [
        {
          attr: {
            text: modalData.button,
            disposable: true,
            modalData: { action: 'close', data: { type: 'current' } },
            customCallbacks: { setServiceData },
            callbackKey: ['setServiceData'],
          },
        },
      ],
    },
  })
}
